export enum AccessType {
    SuperAdmin = 0,
    ServiceProvider = 1,
    Customer = 2, // Service Seeker
    ServiceAdvisor = 3,
    Distributor = 4,
  }
  export enum CreatorAccessType {
    SuperAdmin = 0,
    ServiceProvider = 1,
    Customer = 2,
    ServiceAdvisor = 3,
    Distributor = 4,
  }  